import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { JourneyContext } from "../../CONTEXT/JourneyStore";
import { useHistory, useLocation } from "react-router-dom";
import TransactorService from "../../Services/TransactorService";
import useRiskModelAdaptor from "../../CUSTOMHOOKS/useRiskModelAdaptor";
import DDForm from "./DDForm";
import DDGuarantee from "./DDGuarantee";
import LoggingService from "../../Services/LoggingService";
import SanctionsSearchService from "../../Services/SanctionsSearchService";
import SinglePayment from "./paymentHelpers/SinglePayment";

const Payments = ({
  fromExternalLink = false,
  fromAggregator = false,
  setRotate,
  showPaymentWindow,
  setShowPaymentWindow,
  setPending,
}) => {
  const { search } = useLocation();
  const [gState, setGState] = useContext(JourneyContext);
  const history = useHistory();
  const riskModel = useRiskModelAdaptor(gState);
  const [paymentDiv, setPaymentDiv] = useState(<></>);
  const [error, setError] = useState("");
  const [show3DSWindow, setShow3DSWindow] = useState(false);
  let globalPayAttemptCount =gState.paymentAttempts;
  /*set a popup to lock the UI when the new payments options selected*/
  const [processing, setProcessing] = useState(false);
  const [submittedDDDetails, setSubmittedDDDetails] = useState(false);
  const [
    assumptionsAndDeclarationsAllChecked,
    setAssumptionsAndDeclarationsAllChecked,
  ] = useState(false);
  const amendDetails = (
    <Link
      className="btn btn-wider btn-red float-start"
      to={`/get-a-quote`}
      id="amend-details"
      onClick={() => {
        setGState({
          ...gState,
          yourCoverCrumb: 1,
          yourDetailsCrumb: 1,
          yourQuoteCrumb: 1,
          paymentCrumb: 0,
        });
      }}
    >
      Amend details
    </Link>
  );

  useEffect(() => {
    // users could reset the page, clearing the journey context - if this happens we want them to be returned to the step one. We'll use the bike count to test for a reset
    if (gState.bikes.length === 0) {
      setGState({ yourQuoteCrumb: 0 });
      return history.push(`/get-a-quote${search}`);
    }
  },[]);

  useEffect(() => {
    const allTicked =
      gState.bikes.every((e) => e.lockChecked) &&
      (!gState.bikes.some((s) => s.isElectric) || gState.eBikeTicked) &&
      gState.assumptionsTicked &&
      gState.storageLocationTicked &&
      gState.readDocumentsTicked &&
      gState.paymentTypeIsAnnual !== null;
    setAssumptionsAndDeclarationsAllChecked(allTicked);
    if (allTicked) {
      setGState({ ...gState, clickedPayNow: false });
    } else {
      setShowPaymentWindow(false);
    }
  }, [
    gState.bikes,
    gState.assumptionsTicked,
    gState.storageLocationTicked,
    gState.readDocumentsTicked,
    gState.paymentTypeIsAnnual,
  ]);

  const formik = useFormik({
    initialValues: {
      accountName: "",
      accountNumber: "",
      accountSortCode: "",
      accountBankName: gState.accountBankName,
    },
    validationSchema: Yup.object({
      accountName: Yup.string()
        .required("Account name is required")
        .min(2, "Account name is too short")
        .max(40, "Account name is too long"),
      accountNumber: Yup.string()
        .required("Account number is required")
        .matches(/^\d+$/, "Account number must only contain numbers")
        .min(8, "Account number is too short")
        .max(8, "Account number is too long"),
      accountSortCode: Yup.string()
        .required("Sort code is required")
        .matches(/^\d+$/, "Sort code must only contain numbers")
        .min(6, "Sort code is too short")
        .max(6, "Sort code is too long"),
      accountBankName: Yup.string().required(
        "We cannot find a bank account using these details"
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      // set State
      setGState({
        ...gState,
        accountName: values.accountName,
        accountNumber: values.accountNumber,
        accountSortCode: values.accountSortCode,
        // accountBankName: values.accountBankName,
      });
      // resetForm({ values: "" });
    },
  });

  const handleClickPayNow = async (e) => {
    e.preventDefault();
    setGState({ ...gState, clickedPayNow: true });

    if (gState.paymentTypeIsAnnual == null) {
      setShowPaymentWindow(false);
      const element = document.getElementById("paymentButtons");
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    const allTicked =
      gState.bikes.every((e) => e.lockChecked) &&
      (!gState.bikes.some((s) => s.isElectric) || gState.eBikeTicked) &&
      gState.assumptionsTicked &&
      gState.storageLocationTicked &&
      gState.readDocumentsTicked &&
      gState.paymentTypeIsAnnual !== null;

    if (!allTicked) {
      setShowPaymentWindow(false);
      if (!gState.assumptionsTicked) {
        const element = document.getElementById("assumptionsTicked");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (gState.bikes.some((s) => s.isElectric) && !gState.eBikeTicked) {
        const element = document.getElementById("eBikeTicked");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (!gState.readDocumentsTicked) {
        const element = document.getElementById("readDocumentsTicked");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (!gState.storageLocationTicked) {
        const element = document.getElementById("storageLocationTicked");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (!gState.bikes.every((e) => e.lockChecked)) {
        const element = document.getElementById("lockChecked");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    }
    if (process.env.REACT_APP_SanctionsSearchDisabled === "false") {
      SanctionsSearchService.SanctionSearch(gState)
        .then((data) => {
          if (data.Error) {
            history.push(
              "/QuoteReferred?quoteReference=" + gState.quoteReference
            );
            return;
          }
          if (data.Failure) {
            history.push(
              "/QuoteReferred?quoteReference=" +
                gState.quoteReference.replace("WEB", "REF")
            );
            return;
          }

          setShowPaymentWindow(allTicked);
          if (gState.paymentTypeIsAnnual === true) {
            setPaymentDiv(
              <div>
                <SinglePayment
                  successMethod={handleCompletedPayment}
                  failureMethod={handlePaymentError}
                  gState={gState}
                  uiLock={displayPaymentBlock}
                  threeDS={displayThreeDS}
                />
              </div>
            );
          }
        })
        .catch((err) => {
          history.push(
            "/QuoteReferred?quoteReference=" + gState.quoteReference
          );
          return;
        });
    } else {
      setShowPaymentWindow(allTicked);
      if (gState.paymentTypeIsAnnual === true) {
        setPaymentDiv(
          <div>
            <SinglePayment
              successMethod={handleCompletedPayment}
              failureMethod={handlePaymentError}
              gState={gState}
              uiLock={displayPaymentBlock}
              threeDS={displayThreeDS}
            />
          </div>
        );
      }
    }
  };

  const handleBuyNowClick = async (e) => {
    e.preventDefault();

    if (formik.isValid && formik.dirty) {
      // setPending(true);
      // setRotate(true);
      setGState({ ...gState, DDFormIsValid: true });
    } else {
      setGState({ ...gState, DDFormIsValid: false });
      setPending(false);
      setRotate(false);
      const element = document.getElementById("ddForm");
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      formik.handleSubmit();
      return;
    }
    riskModel.paymentDetails.paymentTypeId =
      process.env.REACT_APP_DIRECT_DEBIT_PAYMENT_TYPE_ID;
    riskModel.paymentDetails.bankDetails = {
      accountNumber: formik.values.accountNumber,
      sortCode: formik.values.accountSortCode,
      AccountHolderName: formik.values.accountName,
    };
    setSubmittedDDDetails(true);
  };

  function displayPaymentBlock(flag) {
    setProcessing(flag);
  }

  function displayThreeDS(flag) {
    setShow3DSWindow(flag);
  }

  function handleCompletedPayment(paymentResult) {
    riskModel.globalPayTransactionId = paymentResult.transactionId;
    riskModel.paymentDetails.paymentTypeId =
      process.env.REACT_APP_CARD_PAYMENT_TYPE_ID;
    LoggingService.logInfo("payment taken- attempting to incept the policy");
    if (gState.paymentTypeIsAnnual === false) {
      riskModel.paymentDetails.paymentTypeId =
        process.env.REACT_APP_DIRECT_DEBIT_PAYMENT_TYPE_ID;
      riskModel.paymentDetails.bankDetails = {
        accountNumber: formik.values.accountNumber,
        sortCode: formik.values.accountSortCode,
        AccountHolderName: formik.values.accountName,
      };
    }
    riskModel.newDD = true;
    // now attempt to incept the policy now that payment has been taken
    const riskModelString = JSON.stringify(riskModel);
    displayPaymentBlock(false);
    displayThreeDS(false);
    setProcessing(false);
    setPending(true);
    setRotate(true);
    tryInceptPolicy(
      riskModelString,
      setPending,
      setRotate,
      history,
      setGState,
      gState
    );
  }

  function handlePaymentError(errorData) {
    setError("Something went wrong with your payment, please try again");
    if (errorData?.length < 1) {
      return;
    }
    console.warn(globalPayAttemptCount)
    if (globalPayAttemptCount < Number(process.env.REACT_APP_GLOBAL_PAY_RETRY_COUNT)) {
      globalPayAttemptCount++;
      setGState({ ...gState, paymentAttempts: globalPayAttemptCount });
      LoggingService.logWarning(errorData);
    } else {
      LoggingService.logError(
        `latest error: ${errorData} - user exceeded retry attempts of ${process.env.REACT_APP_GLOBAL_PAY_RETRY_COUNT} and redirected to error page`
      );
      history.push("/PaymentError?quoteReference=" + gState.quoteReference);
    }
  }
  useEffect(() => {
    // add the bike values in the bikes array
    let runningTotal = 0;
    gState.bikes.forEach((bike) => {
      runningTotal = parseInt(runningTotal) + parseInt(bike.value);
    });

    setGState({
      ...gState,
      combinedHomeValue: runningTotal,
      generateQuote: false,
      yourDetailsCrumb:
        gState.yourDetailsCrumb === 2 ? 1 : gState.yourDetailsCrumb,
      yourQuoteCrumb: gState.yourQuoteCrumb === 2 ? 1 : gState.yourQuoteCrumb,
      yourCoverCrumb: gState.yourCoverCrumb === 2 ? 1 : gState.yourCoverCrumb,
      paymentCrumb: 2,
    });
  }, []);

  return (
    <>
      {gState.paymentSuccessful === false && !gState.paymentTypeIsAnnual && (
        <DDGuarantee readyToRead={assumptionsAndDeclarationsAllChecked} />
      )}
      { false && (
        <>
          <section className="container container_narrow ">
            <div className="content_section mt-3">
              <div className="row">
                <div className="col-4 mb-2">
                  <label className="form-label">
                    Payment amount (used to test payments){" "}
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="amount"
                    required
                    value={gState.annualGrossPremium}
                    onChange={(e) =>
                      setGState({
                        ...gState,
                        annualGrossPremium: e.currentTarget.value,
                        instalmentsFirstPayment: e.currentTarget.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      <div hidden={!processing}>
        <div
          id="payments-overlay"
          className={processing ? "overlay" : "overlay_hidden"}
        >
          <iframe
            hidden={!show3DSWindow}
            id={`payment-iframe-payments`}
            name={`payment-iframe-payments`}
            className={`popup-challenge-payments`}
          ></iframe>
          <h1 hidden={show3DSWindow}>Processing your payment...</h1>
        </div>
      </div>
      <section
        className="container container_narrow "
        hidden={!showPaymentWindow}
      >
        <div className="content_section mt-3  coverSummary">
          {gState.paymentTypeIsAnnual === true && (
            // Full payment
            <div id="card-payment-form" hidden={!showPaymentWindow}>
              <div className="col-12">{paymentDiv}</div>
            </div>
          )}

          {gState.paymentTypeIsAnnual === false && (
            <>
              <section
                className="container container_narrow "
                hidden={!showPaymentWindow}
              >
                <div className=" mt-3 mb-4 ">
                  <div id="dd-payment-form">
                    <div className="col-12">
                      {submittedDDDetails === false && (
                        <DDForm formik={formik} />
                      )}
                      {submittedDDDetails === true && (
                        <div className="row">
                          <h4>
                            Bank details{" "}
                            <span className="blueFont"> Direct Debit</span>
                          </h4>
                          <div className="col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                <span className="textBold">
                                  Name on account:
                                </span>{" "}
                                {formik.values.accountName}
                              </label>
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                <span className="textBold">
                                  {" "}
                                  Account number:
                                </span>{" "}
                                {formik.values.accountNumber}
                              </label>
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                <span className="textBold">Sort code:</span>{" "}
                                {formik.values.accountSortCode}
                              </label>
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                <span className="textBold">Bank name:</span>{" "}
                                {formik.values.accountBankName}
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <button
                              className="btn  btn-primary "
                              onClick={() => setSubmittedDDDetails(false)}
                            >
                              Amend your Direct Debit details
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {error && <small className="redFont mt-1 ">{error}</small>}
                </div>
              </section>
            </>
          )}
        </div>
      </section>

      <section
        className="container container_narrow "
        hidden={submittedDDDetails  === false}
      >
        <div className="content_section mt-3  coverSummary">
          {gState.paymentTypeIsAnnual === false && (
            <>
           
              <section
                className="container container_narrow "
                hidden={submittedDDDetails  === false}
              >
    
                <div hidden={submittedDDDetails === false}>
                <SinglePayment
                  successMethod={handleCompletedPayment}
                  failureMethod={handlePaymentError}
                  gState={gState}
                  uiLock={displayPaymentBlock}
                  threeDS={displayThreeDS}
                  ddPayment={true}
                />
                </div>
              </section>
            </> 
          )}
        </div>
      </section> 

      <section className="container container_narrow ">
        <div className="row">
          <div className="col-12 my-5">
            <div className="" hidden={!fromExternalLink}>
              <div>{amendDetails}</div>
            </div>
            <div className="" hidden={fromExternalLink}>
              <Link
                className="btn btn-wider btn-secondary  float-start mb-2"
                to={`/stepThree${search}`}
              >
                Back
              </Link>
            </div>
            <div className="">
              <button
                className="btn  btn-primary btn-wider float-end"
                hidden={
                  (!showPaymentWindow || gState.paymentTypeIsAnnual === true) || submittedDDDetails
                }
                onClick={async (e) => await handleBuyNowClick(e)}
              >
                Buy now
              </button>
              <button
                className="btn btn-primary btn-wider float-end"
                hidden={showPaymentWindow}
                onClick={async (e) => await handleClickPayNow(e)}
              >
                Pay now
              </button>
              <button
                hidden={
                  !showPaymentWindow || (gState.paymentTypeIsAnnual === false && !submittedDDDetails)
                }
                className="btn btn-primary btn-wider float-end "
                id="rxp-primary-btn"
                type="submit"
                value="Pay Now"
                form="card-payment"
              >
                <span className="hpp-pay"></span> Buy now
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Payments;

function tryInceptPolicy(
  riskModelString,
  setPending,
  setRotate,
  history,
  setGState,
  gState,
  fromAggregator
) {
  window.scrollTo(0, 0);
  const promise = TransactorService.inceptPolicy(
    riskModelString,
    fromAggregator
  );
  promise.then(
    function (result) {
      if (result.success) {
        setRotate(false);
        setPending(false);

        setGState({
          ...gState,
          policyReference: result.value.policyReference,
          paymentSuccessful: true,
          paymentCrumb: 3,
          yourCoverCrumb: 0,
          yourDetailsCrumb: 0,
          yourQuoteCrumb: 0,
        });
        LoggingService.logInfo(
          `Inception succeeded for quote reference: ${gState.quoteReference}, converted to policy: ${result.value.policyReference} `
        );
        history.push(
          `/PolicyConfirmation?policyReference=${result.value.policyReference}`
        );
      } else {
        LoggingService.logError(
          `Inception failed : ${JSON.stringify(result)}, quote reference: ${
            gState.quoteReference
          } `
        );
        history.push("/InceptFailed");
        setPending(false);
        setRotate(false);
      }
    },
    function (err) {
      LoggingService.logError(
        `Inception failed : ${err}, quote reference: ${gState.quoteReference} `
      );
      history.push("/InceptFailed");
      setPending(false);
      setRotate(false);
      return;
    }
  );
}
